import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
} from '@angular/core';

import { TripStateModel } from '@app/modules/core/states/trip-state/trip.model';

import { Passengers } from '../../models/passengers.model';

const INITIAL_PASSENGER_VALUE = 0;
const MAX_PASSENGERS_VALUE = 9;

@Component({
  selector: 'bkg-trip-info-passengers',
  templateUrl: './trip-info-passengers.component.html',
})
export class TripInfoPassengersComponent implements OnChanges {
  @Output() passengers = new EventEmitter<Passengers>();
  @Input() tripData: TripStateModel;

  inPassengers: number = INITIAL_PASSENGER_VALUE;
  outPassengers: number = INITIAL_PASSENGER_VALUE;
  maxPassengers: number = MAX_PASSENGERS_VALUE;

  ngOnChanges(): void {
    if (this.tripData?.in_passengers && this.tripData?.out_passengers) {
      this.inPassengers = this.tripData.in_passengers;
      this.outPassengers = this.tripData.out_passengers;
    }
  }

  onClickAddInPassenger(): void {
    if (this.inPassengers < MAX_PASSENGERS_VALUE) {
      ++this.inPassengers;
      this.outPassengers = this.inPassengers;
      this.emitPassengers();
    }
  }

  onClickRemoveInPassenger(): void {
    if (this.inPassengers && this.inPassengers > INITIAL_PASSENGER_VALUE) {
      --this.inPassengers;
      this.outPassengers = this.inPassengers;
      this.emitPassengers();
    }
  }

  onClickAddOutPassenger(): void {
    if (this.outPassengers < MAX_PASSENGERS_VALUE) {
      ++this.outPassengers;
      this.emitPassengers();
    }
  }

  onClickRemoveOutPassenger(): void {
    if (this.outPassengers && this.outPassengers > INITIAL_PASSENGER_VALUE) {
      --this.outPassengers;
      this.emitPassengers();
    }
  }

  updateInpassenger(): void {
    if (!this.inPassengers || this.inPassengers < 0) {
      this.inPassengers = 0;
    }
    this.outPassengers = this.inPassengers;
    this.emitPassengers();
  }

  updateOutpassenger(): void {
    if (!this.outPassengers || this.outPassengers < 0) {
      this.outPassengers = 0;
    }
    this.emitPassengers();
  }

  private emitPassengers(): void {
    const passengers: Passengers = {
      inPassengers: this.inPassengers,
      outPassenger: this.outPassengers,
    };

    this.passengers.emit(passengers);
  }
}
